module.exports = __webpack_public_path__ + "svg/half-star.7b23acab5dafe761aca6832fe55fe960.svg";